import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";
import { Options } from "./SelectOptions";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    placeOfBirth: string,
    dateOfBirth: Date | null,
    salutation: string,
    street: string,
    postalCode: string,
    city: string,
    salaryRequest: number | null,
    becomingAwareThrough: string,
    becomingAwareThroughOther: string,
    becomingAwareThroughEmployee: string,
    additionalConsent: CheckboxField[],
    letterFile: File | undefined,
    cvFile: File | undefined,
    schoolDiplomaFile: File | undefined,
    pid:string,
    it:string,
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    placeOfBirth: string = "";
    dateOfBirth: Date | null = null;
    salutation: string = "";
    street: string = "";
    postalCode: string = "";
    city: string = "";
    salaryRequest: number | null = null;
    becomingAwareThrough: string="";
    becomingAwareThroughOther: string="";
    becomingAwareThroughEmployee:string="";
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    letterFile: File | undefined = undefined;
    cvFile: File | undefined = undefined;
    schoolDiplomaFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string = "";
    additionalConsent: CheckboxField[] = Options.AdditionalConsent.map((field) => {
        return new CheckboxField(field.value);
    });

    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "placeOfBirth", value: this.placeOfBirth },
            { name: "dateOfBirth", value: this.dateOfBirth?.toString() ?? "" },
            { name: "salutation", value: this.salutation },
            { name: "street", value: this.street },
            { name: "postalCode", value: this.postalCode },
            { name: "city", value: this.city },
            { name: "salaryRequest", value: this.salaryRequest?.toString().replaceAll(" ","") ?? "" },
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
            { name: "becomingAwareThroughOther", value: this.becomingAwareThroughOther },
            { name: "becomingAwareThroughEmployee", value: this.becomingAwareThroughEmployee },
            { name: "additionalConsent", value: this.additionalConsent.filter((field) => field.value === true).map((field) => field.displayName).join(';') },
        );

        return application;
    }
}
